import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { VoraLogo } from "@/components/brand/VoraLogo";
import { VERSION_LEGAL, FECHA_ACTUALIZACION_LEGAL } from "@/lib/legal";

// Oct-2026 · Encabezado y pie compartidos por las páginas legales públicas
// (/aviso-privacidad y /terminos-y-condiciones). Ambas son accesibles SIN sesión.
export function LegalPageShell({ testId, icon, kicker, titulo, children }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4 sm:px-8">
          <Link to="/" className="inline-flex items-center" data-testid="legal-inicio">
            <VoraLogo variant="horizontal" tone="dark" />
          </Link>
          <Link
            to="/login"
            className="inline-flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-primary"
            data-testid="legal-volver-login">
            <ArrowLeft className="h-4 w-4" /> Volver al inicio de sesión
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-10 sm:px-8" data-testid={testId}>
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-primary/10">
            {icon}
          </div>
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500">{kicker}</p>
            <h1 className="font-heading text-2xl font-semibold text-slate-900">{titulo}</h1>
          </div>
        </div>

        <article className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          {children}
        </article>

        <p className="mt-6 text-center text-xs text-slate-500" data-testid="legal-version-footer">
          Última actualización: {FECHA_ACTUALIZACION_LEGAL} · Versión {VERSION_LEGAL} · Servicios
          Legales y Fiscales BLC, S.C.
        </p>
      </main>
    </div>
  );
}
